import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import {Col, Row, UiDivider, UiQuestionnaireLayout, UiText} from '~/components/elements';
import {PAGE_URLS} from '~/constants';
import {WEIGHT_LOSS_KEYS, WEIGHT_LOSS_ONE_QUESTIONNAIRES} from '~/constants/medical-questionnaires';
import {setQuestionnaireAnswer} from '~/redux/questionnaires/slice';
import {submitOrLogMdq} from '~/redux/questionnaires/thunk';
import {RootState} from '~/redux/root-reducer';
import {AppDispatch} from '~/redux/root-store';

interface Props {}

const Questionnaire9NutritionScreen = ({}: Props) => {
  const dispatch: AppDispatch = useDispatch();
  const history = useHistory();
  const mdq = useSelector((state: RootState) => state.questionnaires);
  const {methodKey, medicalUUID, answerOrder} = mdq;
  //   const medicalQuestionnaire = useSelector((state: RootState) => state.questionnaires.medicalQuestionnaire);
  //   const {wpAuthUser} = medicalQuestionnaire;

  //   const questionnaires = medicalQuestionnaire?.questionnaires;
  const questionnaire = WEIGHT_LOSS_ONE_QUESTIONNAIRES.find(i => i.key === WEIGHT_LOSS_KEYS.NUTRITION_WHAT_INCLUDED);

  const collectedData = mdq.collectedData;

  const onClickSubmit = () => {
    const answerData = {
      key: WEIGHT_LOSS_KEYS.NUTRITION_WHAT_INCLUDED,
      index: questionnaire?.index || '',
      data: {},
      order: answerOrder + 1,
    };

    dispatch(setQuestionnaireAnswer(answerData));
    dispatch(
      submitOrLogMdq({
        data: {
          uid: medicalUUID,
          methodKey: methodKey.toLowerCase(),
          status: 'draft',
          data: {
            ...collectedData,
            [WEIGHT_LOSS_KEYS.NUTRITION_WHAT_INCLUDED]: answerData,
          },
        },
      }),
    );
    // dispatch(setNextQuestionnaire({value: WEIGHT_LOSS_KEYS.ELEVATE_PROGRAM_GOALS}));
    history.push(PAGE_URLS.MDQ1_SELECT_NUTRITION_PACKAGE);
  };

  return (
    <UiQuestionnaireLayout
      actions={questionnaire?.actions}
      checkoutStep={questionnaire?.checkoutStep}
      handleOnNext={onClickSubmit}
      pageTitle={questionnaire?.title}
    >
      <Col alignItems="center" textAlign="center" mt={12} px={2}>
        <UiText fontSize="xl" fontWeight="bold" mb={7}>
          {questionnaire?.questions?.default}
        </UiText>
        {questionnaire?.includeItems?.map(item => (
          <Col key={item.key} textAlign="left">
            <UiText fontWeight="bold" mb={3}>
              {item.label}
            </UiText>
            <UiText fontSize="sm" fontWeight="500" mb={3} pr={6}>
              {item.description}
            </UiText>
            {item.items?.length && (
              <Row flexWrap="wrap">
                {item.items?.map(subItem => (
                  <Col key={subItem.key} width="33%" mb={2}>
                    <img
                      src={subItem.image}
                      alt={subItem.label}
                      style={{width: '95px', height: '6rem', maxWidth: 'none', objectFit: 'contain'}}
                    />
                    <UiText fontSize="0.625rem" fontWeight="500" mt={1} pl={2}>
                      {subItem.label}
                    </UiText>
                  </Col>
                ))}
              </Row>
            )}
            {item.subDescription && (
              <UiText textAlign="center" fontSize="sm" fontWeight="500" mt={3}>
                {item.subDescription}
              </UiText>
            )}
            {item.showDivider && <UiDivider my={6} />}
          </Col>
        ))}
      </Col>
    </UiQuestionnaireLayout>
  );
};

export default Questionnaire9NutritionScreen;
